import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect'
import { useEffect } from 'react';

export const ProgPeriodicity = ({ fieldDef }) => {

  const { entityFormMode } = useEntityMgr();
  const { formValues, assignValue } = useForm();

  useEffect(() => {
    if (entityFormMode === EntityFormMode.VIEW) return; 

    const invDateTypes = ['SUPP', 'MEDI', 'ADAP', 'SPAP', 'JCODE', 'MM'];
    if (invDateTypes.includes(formValues.progType)) {
      assignValue('pymtPeriodicity', 'QTR');
      fieldDef.disabled = true;
    } else {
      assignValue('pymtPeriodicity', null);
      fieldDef.disabled = false;
    }

  }, [formValues.progType]);


  return <EnumSelect fieldDef={fieldDef}/>
}